import script from "./DiscardOrderButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscardOrderButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__